import React, {useEffect, useState} from 'react';
import {useTranslation} from "react-i18next";
import axios from "axios";
import DataCompareService from "../../services/DataCompareService";
import DataParseService from "../../services/DataParseService";
import {Container, Row} from "react-bootstrap";
import TitleAndInputBox from "../common/dataView/TitleAndInputBox";
import Modal from "react-modal";
import UserService from '../../services/UserService';
import ModalCloseButton from "../common/modal/ModalCloseButton";
import {toast} from "react-toastify";
import ToastAlertView from "../common/alert/ToastAlertView";
import useAxios from "../../customHooks/useAxios";

const requestBodyInit = {
    onShipCompleteDate : "",
    comment : ""
};

const isValidMapInit = {
    onShipCompleteDate : false,
    comment : false
};

const modalStyle = {
    overlay: {
        backgroundColor: 'rgba(0, 0, 0, 0.5)'
    },
    content: {
        color: 'black',
        width: '400px',
        height: '320px',
        margin: 'auto'
    }
}

const EditCompleteInfo = ({ orderId, isOpen, setIsOpen, onRefresh, prevData }) => {

    /** New : axios hook */
    const { isAxiosLoading, axiosCall } = useAxios();

    const { t } = useTranslation();
    const [fixedData, setFixedData] = useState(requestBodyInit);
    const [requestBody, setRequestBody] = useState(requestBodyInit);
    const [isValidMap, setIsValidMap] = useState(isValidMapInit);
    const [isValid, setIsValid] = useState(false);
    const [isEdited, setIsEdited] = useState(false);

    /* utils */
    const updateRequestBody = (key, value) => {
        setRequestBody(prevObj => {
            let newObj = {...prevObj};
            newObj[key] = value;
            return newObj;
        })
    };

    const updateIsValidMap = (key, value) => {
        setIsValidMap(prevObj => {
            let newObj = {...prevObj};
            newObj[key] = value;
            return newObj;
        })
    };

    /* handlers */
    const handleOnShipCompleteDateInput = (value) => {
        updateRequestBody("onShipCompleteDate", value);
    }

    const handleCommentInput = (value) => {
        updateRequestBody("comment", value);
    }

    /* validators */
    const validateOnShipCompleteDate = () => {
        if (requestBody["onShipCompleteDate"] === "") {
            updateIsValidMap("onShipCompleteDate", false);
        } else {
            updateIsValidMap("onShipCompleteDate", true);
        }
    }

    const validateComment = () => {
        if (requestBody["comment"] === "") {
            updateIsValidMap("comment", false);
        } else {
            updateIsValidMap("comment", true);
        }
    };

    /* edit onShip information (PUT) */
    const putOnShipInfo = async () => {
        try {
            await axiosCall(
                "PUT",
                '/order/:1/complete',
                [orderId],
                requestBody,
                null,
                {},
                "default"
            );
            toast.success(<ToastAlertView message={t("message.saved")} />);
            onRefresh();
            setIsOpen(false);
        } catch (e) {
            toast.error(<ToastAlertView message={t("message.failed")} />);
            console.log(e);
        }
    };

    /* effects */
    /* validate */
    useEffect(() => {
        validateOnShipCompleteDate();
    }, [requestBody["onShipCompleteDate"]]);

    useEffect(() => {
        validateComment();
    }, [requestBody["comment"]]);

    useEffect(() => {
        setRequestBody(() => {
            let data = DataCompareService.deepCopyObj(prevData);
            let newRequestBody = {};
            newRequestBody["onShipCompleteDate"] = DataParseService.dateTimeToDate(data["onShipCompleteDate"]);
            newRequestBody["comment"] = "";
            return newRequestBody;
        });
        setFixedData(() => {
            let data = DataCompareService.deepCopyObj(prevData);
            let newRequestBody = {};
            newRequestBody["onShipCompleteDate"] = DataParseService.dateTimeToDate(data["onShipCompleteDate"]);
            newRequestBody["comment"] = "";
            return newRequestBody;
        });
    }, [prevData]);

    /* isEdited */
    useEffect(() => {
        setIsEdited(!DataCompareService.isSameObj(fixedData, requestBody));
    }, [requestBody]);

    /* isValid */
    useEffect(() => {
        setIsValid(DataCompareService.checkIsAllTrue(isValidMap));
    }, [isValidMap]);

    useEffect(() => {
        setFixedData(requestBodyInit);
        setRequestBody(requestBodyInit);
        setIsValidMap(isValidMapInit);
        setIsValid(false);
        setIsEdited(false);
    }, [isOpen]);

    return (
        <Modal
            style={modalStyle}
            isOpen={isOpen}
            onRequestClose={() => {
                onRefresh();
                setIsOpen(false);
            }}
        >
            <ModalCloseButton
                title={t("menu.order.detail.content.editComplete")}
                setIsOpen={setIsOpen}
            />
            <div
                style={{
                    width: '100%',
                    height: '220px'
                }}
            >
                <Container fluid>
                    <Row>
                        <TitleAndInputBox
                            title={t("menu.order.detail.content.deliveryHistory.OnShipCompleteDate")}
                            value={requestBody["onShipCompleteDate"]}
                            onChange={handleOnShipCompleteDateInput}
                            isForEdit={true}
                            type={"date"}
                            isValid={isValidMap["onShipCompleteDate"]}
                            isEnabled={true}
                        />
                    </Row>
                    <Row
                        style={{ marginTop: '5px' }}
                    >
                        <TitleAndInputBox
                            title={t("menu.order.detail.content.deliveryHistory.comment")}
                            value={requestBody["comment"]}
                            onChange={handleCommentInput}
                            isForEdit={true}
                            type={"text"}
                            isValid={isValidMap["comment"]}
                            isEnabled={true}
                        />
                    </Row>
                    <Row>
                        <div
                            style={{
                                width: '100%',
                                marginTop: '25px'
                            }}
                        >
                            {
                                (isValid && isEdited) ?
                                    <button
                                        id={"long-save-btn"}
                                        onClick={() => putOnShipInfo()}
                                    >
                                        {t("button.save")}
                                    </button>
                                    :
                                    <button
                                        id={"long-save-btn-disabled"}
                                    >
                                        {t("button.save")}
                                    </button>
                            }
                        </div>
                    </Row>
                </Container>
            </div>
        </Modal>
    );
};

export default EditCompleteInfo;